module.exports = __webpack_public_path__ + "images/JDBC2.svg";